// import React, { useState, useEffect } from 'react';
// import { Container, Typography, Grid, Card, CardContent, CardActionArea, Box, Chip } from '@mui/material';
// import { Link } from 'react-router-dom';

// const BlogIndex = () => {
//   const [posts, setPosts] = useState([]);

//   useEffect(() => {
//     // Load posts from localStorage
//     const savedPosts = localStorage.getItem('freshsweeper_blog_posts');
//     if (savedPosts) {
//       setPosts(JSON.parse(savedPosts));
//     } else {
//       // Default posts if none exist
//       const defaultPosts = [
//         {
//           id: 1,
//           title: "How to Automate Your Airbnb Turnovers",
//           slug: "automate-turnovers",
//           excerpt: "Learn how to set up automated scheduling so you never miss a turnover...",
//           date: "2024-04-28",
//           category: "For Hosts",
//           image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop"
//         },
//         {
//           id: 2,
//           title: "How to Get More Cleaning Jobs",
//           slug: "more-cleaning-jobs",
//           excerpt: "Proven strategies to fill your schedule with repeat clients...",
//           date: "2024-04-27",
//           category: "For Cleaners",
//           image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=400&fit=crop"
//         }
//       ];
//       setPosts(defaultPosts);
//       localStorage.setItem('freshsweeper_blog_posts', JSON.stringify(defaultPosts));
//     }
//   }, []);

//   // Format date to readable format
//   const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   return (
//     <Container maxWidth="lg" sx={{ py: 6 }}>
//       <Typography variant="h2" sx={{ fontWeight: 800, mb: 2, textAlign: 'center' }}>
//         FreshSweeper Blog
//       </Typography>
//       <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary', mb: 6, maxWidth: 600, mx: 'auto' }}>
//         Expert tips for Airbnb hosts and professional cleaners
//       </Typography>

//       <Grid container spacing={4}>
//         {posts.map((post) => (
//           <Grid item xs={12} md={4} key={post.id}>
//             <Card sx={{ height: '100%', transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-4px)' } }}>
//               <CardActionArea component={Link} to={`/blog/${post.slug}`}>
//                 <Box
//                   component="img"
//                   src={post.image}
//                   alt={post.title}
//                   sx={{ width: '100%', height: 200, objectFit: 'cover' }}
//                 />
//                 <CardContent>
//                   <Chip label={post.category} size="small" sx={{ mb: 2 }} />
//                   <Typography variant="h6" fontWeight="700" gutterBottom>
//                     {post.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                     {post.excerpt}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     {formatDate(post.date)}
//                   </Typography>
//                 </CardContent>
//               </CardActionArea>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>
//     </Container>
//   );
// };

// export default BlogIndex;



import React, { useState, useEffect } from 'react';
import { 
  Container, Typography, Grid, Card, CardContent, CardActionArea, 
  Box, Chip, Pagination, Stack, FormControl, InputLabel, Select, MenuItem, CircularProgress, Alert
} from '@mui/material';
import { Link } from 'react-router-dom';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

// Adjust this URL for production (use relative path or environment variable)
const API_URL = process.env.NODE_ENV === 'production' ? '' : 'https://www.freshsweeper.com';

const BlogIndex = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(`${API_URL}/api/blog/posts?limit=100`); // fetch all posts for pagination on client
        if (!response.ok) throw new Error('Failed to fetch blog posts');
        const data = await response.json();
        setPosts(data);
        setTotalPages(Math.ceil(data.length / postsPerPage));
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []); // runs once on mount

  // Update total pages when postsPerPage changes
  useEffect(() => {
    setTotalPages(Math.ceil(posts.length / postsPerPage));
    setPage(1); // reset to first page
  }, [postsPerPage, posts]);

  // Get current posts for the page
  const indexOfLastPost = page * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePostsPerPageChange = (event) => {
    setPostsPerPage(event.target.value);
  };

  const isVideoPost = (content) => {
    if (!content) return false;
    return content.includes('youtube.com/embed') || 
           content.includes('youtu.be') || 
           content.includes('youtube.com/watch');
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container sx={{ py: 8 }}>
        <Alert severity="error">Could not load blog posts: {error}</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Typography variant="h2" sx={{ fontWeight: 800, mb: 2, textAlign: 'center' }}>
        FreshSweeper Blog
      </Typography>
      <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary', mb: 6, maxWidth: 600, mx: 'auto' }}>
        Expert tips for Airbnb hosts and professional cleaners
      </Typography>

      {/* Posts Per Page Selector */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Show</InputLabel>
          <Select
            value={postsPerPage}
            label="Show"
            onChange={handlePostsPerPageChange}
          >
            <MenuItem value={3}>3 per page</MenuItem>
            <MenuItem value={6}>6 per page</MenuItem>
            <MenuItem value={9}>9 per page</MenuItem>
            <MenuItem value={12}>12 per page</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Posts Grid */}
      <Grid container spacing={4}>
        {currentPosts.map((post) => {
          const hasVideo = isVideoPost(post.content);
          return (
            <Grid item xs={12} md={4} key={post.id}>
              <Card sx={{ height: '100%', transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-4px)' } }}>
                <CardActionArea component={Link} to={`/blog/${post.slug}`}>
                  <Box sx={{ position: 'relative' }}>
                    <Box
                      component="img"
                      src={post.image || 'https://placehold.co/600x400/3b82f6/white?text=FreshSweeper'}
                      alt={post.title}
                      sx={{ width: '100%', height: 200, objectFit: 'cover' }}
                    />
                    {hasVideo && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          bgcolor: 'rgba(0,0,0,0.4)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            bgcolor: 'rgba(0,0,0,0.5)',
                          },
                        }}
                      >
                        <PlayCircleIcon 
                          sx={{ 
                            fontSize: 60, 
                            color: 'white',
                            transition: 'transform 0.2s',
                            '&:hover': {
                              transform: 'scale(1.1)',
                            },
                          }} 
                        />
                      </Box>
                    )}
                    {hasVideo && (
                      <Chip
                        label="Video"
                        size="small"
                        icon={<PlayCircleIcon sx={{ fontSize: 14 }} />}
                        sx={{
                          position: 'absolute',
                          top: 8,
                          right: 8,
                          bgcolor: 'rgba(0,0,0,0.7)',
                          color: 'white',
                          '& .MuiChip-icon': { color: 'white' },
                        }}
                      />
                    )}
                  </Box>
                  <CardContent>
                    <Chip label={post.category} size="small" sx={{ mb: 2 }} />
                    <Typography variant="h6" fontWeight="700" gutterBottom>
                      {post.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      {post.excerpt}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {formatDate(post.date)}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Pagination */}
      {totalPages > 1 && (
        <Stack spacing={2} alignItems="center" sx={{ mt: 6 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
            sx={{
              '& .MuiPaginationItem-root': {
                borderRadius: 2,
              },
            }}
          />
          <Typography variant="body2" color="text.secondary">
            Showing {indexOfFirstPost + 1} to {Math.min(indexOfLastPost, posts.length)} of {posts.length} posts
          </Typography>
        </Stack>
      )}
    </Container>
  );
};

export default BlogIndex;